import React, { memo, useEffect, useState } from "react";

import defaultPlaceholder from "../../images/default-placeholder.png";
import { MEMOIZED_DOMAIN_URL } from "components/util/HostUtils";
import moment from "moment";
import _ from "lodash";
import { getVideoFromSessionTimestamp } from "redux/actions/videoFromTimestampActions";
import { useDispatch, useSelector } from "react-redux";
import OBCSpinner from "components/util/OBC";

const WHITELISTED_TAGS = ["day", "night", "forward", "backward"];

const csrfTokenSelector = (state) => state.csrfToken;

const ITEM_GUTTER_SIZE = 10;

const LocationResultRow = memo(({ session, isHighlighted, dashboardData = {}, style, onSessionClick }) => {
    const [imageData, setImageData] = useState(null);
    const [loadingImageData, setLoadingImageData] = useState(true);
    const [requestedImageData, setRequestedImageData] = useState(false);

    const csrfToken = useSelector(csrfTokenSelector);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!requestedImageData) {
            const clonedSession = _.cloneDeep(session);
            dispatch(getVideoFromSessionTimestamp(clonedSession.session_id, clonedSession.timestamp)).then((videoData) => {
                setLoadingImageData(false);
                setImageData(videoData);
                setRequestedImageData(true);
            });
        }
    }, [dispatch, requestedImageData, session]);

    const image = () => {
        if (loadingImageData) {
            return (
                <OBCSpinner
                    size={50}
                    speed={3}
                    color={"#e8dfff"}
                />
            );
        }

        const firstSource = _.get(session.stream_info, [0, "source"]);
        const sourceImageData = _.get(imageData, [firstSource]);

        let imageURL = defaultPlaceholder;

        if (sourceImageData) {
            imageURL = `https://raw${MEMOIZED_DOMAIN_URL}/${sourceImageData[0]}/${sourceImageData[1]}/${sourceImageData[2]}.jpg`;

            if (csrfToken) {
                imageURL += `?csrf=${csrfToken}`;
            }
        }

        return (
            <img
                src={imageURL}
                alt="Session thumbnail"
                crossOrigin={"anonymous"}
            />
        );
    };

    const date = moment(session.timestamp).format("lll");

    const tags = _.filter(session.session_tags, (tag) => WHITELISTED_TAGS.includes(String(tag).toLocaleLowerCase()));

    return (
        <div
            style={{
                ...style,
                top: style.top + ITEM_GUTTER_SIZE,
                height: style.height - ITEM_GUTTER_SIZE,
                left: style.left + 2,
                width: style.width - 4,
            }}
            key={session.session_id}
            className={"searchSessionListItem" + (dashboardData.unknown ? " disabled" : "") + (isHighlighted ? " Highlight" : "")}
            onClick={() => !dashboardData.unknown && onSessionClick(session)}>
            <div className="searchSessionListItem__Image">{image()}</div>
            <div className="searchSessionListItem__Info">
                <p className="searchSessionListID">{`#${session.session_id}`}</p>
                <p className="searchSessionListTitle">{session.name}</p>
                <p className="searchSessionListTags">{tags.join(", ")}</p>
                <p className="date">{date}</p>
            </div>
        </div>
    );
});

export default LocationResultRow;
